<template>
  <div class="mb10">
    <form @onsubmit.prevent action>
      <div class="row">
        <div class="col col-md-12">
          <div class="form-group">
            <label class="col-form-label">Comment(s)</label>
            <vue-ckeditor
              id="comments"
              v-model="comments"
              :config="config"
              @blur="onBlur($event)"
              @focus="onFocus($event)"
              @contentDom="onContentDom($event)"
              @dialogDefinition="onDialogDefinition($event)"
              @fileUploadRequest="onFileUploadRequest($event)"
              @fileUploadResponse="onFileUploadResponse($event)"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group pull-right">
            <!-- <submitButton @click.prevent="submit" type="submit" class="btn btn-info">Submit</submitButton> -->
            <button @click="save" type="button" class="btn btn-primary">Save</button>
          </div>
        </div>
      </div>
      <PinCheck
        :show.sync="show"
        ref="smallModal"
        v-bind:small="true"
        @submitForm="submitForm"
        :cancelClass="'btn btn-secondary'"
      ></PinCheck>
    </form>
  </div>
</template>

<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import PinCheck from "@/components/PinCheck.vue";
import VueCkeditor from "vue-ckeditor2";
export default {
  components: { PinCheck, VueCkeditor },
  mixins: [commonMixins],
  props: ["companyData", "isFromComp", "selCompany"],
  created() {
    console.log("Company general Selected Company", this.selCompany);
    this.getCompanyComments();
  },
  data() {
    return {
      show: false,
      curDate: new Date(),
      compSel: {},
      comments: "",
      config: {
        toolbar: [
          {
            name: "snddocument",
            items: [
              "Source",
              "-",
              "Save",
              "NewPage",
              "DocProps",
              "Preview",
              "Print",
              "-",
              "Templates"
            ]
          },
          { name: "clipboard", items: ["Undo", "Redo"] },
          {
            name: "editing",
            items: [
              "Find",
              "Replace",
              "-",
              "SelectAll",
              "-",
              "SpellChecker",
              "Scayt"
            ]
          },
          {
            name: "forms",
            items: [
              "Form",
              "Checkbox",
              "Radio",
              "TextField",
              "Textarea",
              "Select",
              "Button",
              "ImageButton",
              "HiddenField"
            ]
          },
          "/",
          {
            name: "basicstyles",
            items: [
              "Bold",
              "Italic",
              "Underline",
              "Strike",
              "Subscript",
              "Superscript",
              "-",
              "RemoveFormat"
            ]
          },
          {
            name: "paragraph",
            items: [
              "NumberedList",
              "BulletedList",
              "-",
              "Outdent",
              "Indent",
              "-",
              "Blockquote",
              "CreateDiv",
              "-",
              "JustifyLeft",
              "JustifyCenter",
              "JustifyRight",
              "JustifyBlock",
              "-",
              "BidiLtr",
              "BidiRtl"
            ]
          },
          { name: "links", items: ["Link", "Unlink", "Anchor"] },
          {
            name: "insert",
            items: [
              "Image",
              // "Flash",
              "Table",
              "HorizontalRule",
              "Smiley",
              "SpecialChar",
              "PageBreak",
              "Iframe"
            ]
          },
          { name: "styles", items: ["Styles", "Format", "FontSize"] },
          { name: "colors", items: ["TextColor", "BGColor"] },
          { name: "tools", items: ["Maximize", "ShowBlocks"] }
        ]
      }
    };
  },
  methods: {
    onBlur(evt) {
      console.log(evt);
    },
    onFocus(evt) {
      console.log(evt);
    },
    onContentDom(evt) {
      console.log(evt);
    },
    onDialogDefinition(evt) {
      console.log(evt);
    },
    onFileUploadRequest(evt) {
      console.log(evt);
    },
    onFileUploadResponse(evt) {
      console.log(evt);
    },
    submitForm() {
      console.log("submitpin entered");
      // this.validatePin(pin);
      const data = {
        co_code: this.selCompany.co_code,
        comment: this.comments
      };
      http.post("companyGeneralComments/update", data, (error, response) => {
        console.log("Response", response);
        if (response.responseType === "success") {
          this.$toastr.success("Updated Successfully!", "", {});
        } else {
          this.$toastr.error("Error", "", {});
        }
      });
    },
    save() {
      this.$refs.smallModal.open();
    },
    getCompanyComments() {
      http.get(
        "companyGeneralComments/edit/" + this.selCompany.co_code,
        {},
        (error, response) => {
          console.log("Response", response);
          if (response.length > 0) {
            this.comments = response[0].comment;
          }
        }
      );
    }
  },
  watch: {
    companyData: function(value) {
      console.log("Sel comp Value", value);
    },
    selCompany: function(value) {
      // console.log("Company Name", value);
      this.compSel = value;
      this.getCompanyComments();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/manual-forms/company-general-data.vue